import { forwardRef } from "react";

import { useSiteData } from "../../contexts/SiteDataContext";
import { useLocale } from "../../i18n/LocaleContext";
import { useLocalized } from "../../i18n/localized";

const MainPageInfo = forwardRef<HTMLElement>((_props, ref) => {
  const { siteData } = useSiteData();
  const { t } = useLocale();
  const text = useLocalized();

  return (
    <section ref={ref} className="w-full footer-bg-image text-white">
      <div className="container-md 2xl:px-0 px-3 mx-auto pt-16 pb-16 md:pt-[7.5rem] md:pb-[7.5rem] min-h-[31.25rem]">
        <h2 className="text-[1.5rem] md:text-[2rem] font-bold leading-[120%] tracking-[0.01em] text-white mb-3 text-left md:text-center">
          {text(siteData?.our_criteria, "title")}
        </h2>

        <div
          dangerouslySetInnerHTML={{
            __html: text(siteData?.our_criteria, "content"),
          }}
          className="criteria-copy mb-[3.75rem]"
        />

        <div className="flex justify-center">
          <a
            href="/protocol"
            className="button inline-block bg-yellow text-sm md:text-lg font-extrabold leading-0 rounded-lg text-center py-4 px-12 md:py-6"
            data-umami-event="Main Page Details Click"
          >
            {t("main.learnMore")}
          </a>
        </div>
      </div>
    </section>
  );
});

MainPageInfo.displayName = "MainPageInfo";

export default MainPageInfo;
